angular.module('impactx.catalog').controller('ImportProductDataCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    ImportProductDataCtrl
]);

function ImportProductDataCtrl($scope, dataGen, ToastService, $mdDialog, TranslationService) {
    var ctrl = this;
    $scope.requiredLabel = TranslationService.get("required");
    $scope.uploadExcel = {};

    dataGen.getData({}, {catId: ctrl.catId, supplierId: 0, setMatchCode: null, hiddenMatchCode: "net_customer (EUR)"}, "/cscontract/vkpricegroup", null, true).then(function (data) {
        $scope.priceGroup = data.data
    });

    ctrl.import = function (event) {
        $scope.uploadInProgress = true;
        var paramObj = {
            catId: ctrl.catId,
            psgMatchCode: $scope.priceGroup.selected!=null? $scope.priceGroup.selected.id : "",
            file: $scope.uploadExcel.file
        };
        dataGen.uploadFile(paramObj, '/catalog/import/excel/product', true).then(function (resp) {
            $scope.uploadInProgress = false;
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        }, function (resp) {
            $scope.uploadInProgress = false;
            if (resp && resp.data && resp.data.catId) {
                ctrl.catId = resp.data.catId;
            }
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

}